import { Component, Input } from '@angular/core';
import { Transaction } from '../../models/transactionmodel';
import { Recon } from '../../models/reconmodel';
import { Search } from '../../models/searchmodel';
import { transactionService }   from '../../services/transaction.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { ReconFile } from '../../models/reconfilemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import * as alaSQLSpace from 'alasql';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';

@Component({
  templateUrl: './recon.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [transactionService]
})

export class ReconComponent {
  @Input() responseObj: Session;
  public transactions: Transaction[];
  public recon: Recon;
  public search: Search;
  public enablestorefield: boolean;
  errorMessage: string;
  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [],
    showTitle: true,
    title: 'asfasf',
    useBom: false,
    removeNewLines: true,
    keys: ['storeid','reflect','merchantreference' ]
  };
  public data;
  public objectKeys = Object.keys;
  public transno = 0;
  public res : ReconFile[];
 

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy-mm-dd',
  };

  private selDate: IMyDate = {year: 0, month: 0, day: 0};
  csvContent: string;
  constructor(private _transactionService: transactionService, public router: Router, public sharedservice: SharedService) {

  }
 

  ngOnInit()
  {
      this.recon = new Recon();      
  }

  onFileLoad(fileLoadedEvent) {
    const textFromFileLoaded = fileLoadedEvent.target.result;
    this.csvContent = textFromFileLoaded;
    var result = [];

    var rows = this.csvContent.toString().split('\n');
    var headers = rows[0].split(",");

    for (var i = 1; i < rows.length-1; i++) {    
        var obj = {};
        var currentline = rows[i].split(",");
        for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];            
        }

        result.push(obj);
    }

    let other = []; // your other array...

    result.map(item => {
        return {
            storeid: item.storeid,
            merchantreference: item.merchantreference,
            reflect: 'YES'
        }
    }).forEach(item => other.push(item));

    this.res = JSON.parse(JSON.stringify(other));
    this.data = this.res;  
    console.log('Result : ' + JSON.stringify(this.res));

    console.log('Other : ' + other[0].storeid);
    console.log('Other : ' + other[1].storeid);
    console.log('Other : ' + other[2].storeid);  

  }

  
  onFileSelect(input: HTMLInputElement) {
        const files = input.files;

        var content = this.csvContent;
        if (files && files.length) {
            const fileToRead = files[0];
            const fileReader = new FileReader();
            fileReader.onload = this.onFileLoad;
            fileReader.readAsText(fileToRead, "UTF-8");
        }   

        console.log('RES : ' + JSON.stringify(this.res));
             
        
  }

  reconcileTransaction(){
    this._transactionService.reconcileTransaction(this.recon).subscribe(res => res, error => this.errorMessage = <any>error);
  }

  exportXLS() {
    var data = this.transactions;
    var opts = [{ sheetid: 'Data', header: true }];
    alasql('SELECT INTO XLSX("report.xlsx",?) FROM ?', [opts, [data]]);
  }

  exportCSV() {
    var data = this.transactions;
    var opts = [{header: true }];
     alasql('SELECT INTO CSV("report.csv",{header: true}) FROM ?', [opts, data]);
   }

   replacer(i, val) {
    if ( val === null ) {
        return ""; // Change null to empty
    } else if ( val === "\r" ) {
        return ""; // Change null to empty
    } 
    else {
        return val; // return unchanged
    }
  }


  handleResponse(result){
    //console.log(JSON.stringify(result));
    //this.transactions = JSON.parse(JSON.stringify(result, this.replacer));;
    //this.data = this.transactions;
    //this.transno = result != null ? this.objectKeys(this.transactions).length : 0;
  }


}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/app/recon/recon.component.ts